exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-color[data-v-1ccb1c7a]{background-color:var(--systemMainColor);color:var(--colorLumpText)}.btn-color[data-v-1ccb1c7a]{color:var(--systemMainColor)}.title-color[data-v-1ccb1c7a]{background-color:var(--transferTitleBg)}.bg-title[data-v-1ccb1c7a]{color:var(--titleTextColor);background-color:var(--collapseHeadHeaderBg);border-color:var(--collapseBorder)}.el-popper.tag_select-popper .el-select-dropdown__item[data-v-1ccb1c7a]{height:100%!important;padding:0}", ""]);

// exports
